import config from '../config/config';

const MS_PER_DAY = 86400000; // 24 * 60 * 60 * 1000
const MONTH_OFFSET = 1;
const PAD_LENGTH = 2;

/**
 * Date オブジェクトを UTC の "YYYYMMDDHHmm" 形式に変換
 * @param {Date} d
 * @returns {string}
 */
function formatUtcYYYYMMDDHHmm(d) {
  const pad = (n) => String(n).padStart(PAD_LENGTH, '0');
  return (
    d.getUTCFullYear().toString() +
    pad(d.getUTCMonth() + MONTH_OFFSET) +
    pad(d.getUTCDate()) +
    pad(d.getUTCHours()) +
    pad(d.getUTCMinutes())
  );
}

/**
 * 今日と明日の UTC 時刻を "YYYYMMDDHHmm|YYYYMMDDHHmm" で返す
 * @param {Date} [baseDate=new Date()] - 基準日（省略時は現在日時）
 * @returns {string}
 */
export function generateTodayTomorrowPipe(baseDate = new Date()) {
  const today = new Date(baseDate.getTime());
  const tomorrow = new Date(baseDate.getTime() + MS_PER_DAY);
  return `${formatUtcYYYYMMDDHHmm(today)}|${formatUtcYYYYMMDDHHmm(tomorrow)}`;
}

/**
 * 日の出、日の入を取得する関数
 * @param {number} lat - 緯度
 * @param {number} lng - 経度
 * @param {Date} [baseDate=new Date()] - 基準日（省略時は現在日時）
 * @returns {Promise<number|string>} 日の出、日の入の時刻
 */
export async function fetchSunsetAndSunrise(lat, lng, baseDate = new Date()) {
  try {
    const dateStr = generateTodayTomorrowPipe(baseDate);

    // sunmoonAPIのURLを生成
    const url = config.api.map.sunmoon(lng, lat, dateStr);
    const response = await fetch(url);
    const data = await response.json();
    if (data?.result) {
      return data.result
    }
    return null;
  } catch (error) {
    return null;
  }
}
